import axios from "./custom_axios";
import Cookies from 'js-cookie';
const API_URL = process.env.REACT_APP_API_URL;

const fetchRegions = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/v1/regions`);
        return response.data;
    } catch (error) {
        return [];
    }
}

export { fetchRegions }
